export const reportsConstants = {
    errors: {
        fetchFailed: "Failed to load project report.",
        exportFailed: "Failed to export report.",
        genericError: "Something went wrong.",
    },
    messages: {
        exportStarted: "Preparing export...",
    },
};
